var map = {
	"./add.svg": "6828",
	"./ai-icon.svg": "d44f",
	"./arrow-left-circle-thin.svg": "1e58",
	"./arrow-left-small.svg": "f0f4",
	"./arrow-left-thin.svg": "cb2f",
	"./arrow-left.svg": "f3a0",
	"./arrow-right-small.svg": "1c7f",
	"./board-icon.svg": "dec4",
	"./building.svg": "2a26",
	"./chart-to-settings.svg": "f5a8",
	"./chart.svg": "9f3b",
	"./checkbox.svg": "551a",
	"./checkboxcard.svg": "e0f2",
	"./clipboards.svg": "c18a",
	"./clock-icon.svg": "5a8c",
	"./code-tag.svg": "c768",
	"./codelos-icons.svg": "b3e6",
	"./cog.svg": "d6e4",
	"./condition.svg": "1297",
	"./condition_pink.svg": "60e1",
	"./copy_grey.svg": "e94a",
	"./dark-chart-to-settings.svg": "9e2e",
	"./dark-settings-to-chart.svg": "b450",
	"./database-gray.svg": "736f",
	"./database-light.svg": "a77b",
	"./database-link.svg": "0ab9",
	"./database-model.svg": "06c0",
	"./database.svg": "60d8",
	"./date.svg": "767c",
	"./datetime.svg": "5217",
	"./delete-icon.svg": "cd73",
	"./delete.svg": "26a0",
	"./delete_grey.svg": "01ce",
	"./description.svg": "77bd",
	"./document.svg": "5fe1",
	"./download.svg": "9f0f",
	"./download_grey.svg": "6e63",
	"./dropdown-icon.svg": "3914",
	"./duplicate.svg": "c05b",
	"./edit.svg": "66d5",
	"./expired.svg": "a924",
	"./file.svg": "ea02",
	"./filter.svg": "c86e",
	"./hidden.svg": "47c0",
	"./html.svg": "9f43",
	"./icons-icon.svg": "a3f1",
	"./image-icon.svg": "6eb4",
	"./leave.svg": "6be8",
	"./left-arrow.svg": "f330",
	"./line.svg": "4d6d",
	"./link-to-db.svg": "a964",
	"./list icon.svg": "e7a0",
	"./list.svg": "764e",
	"./lock-locked.svg": "aba3",
	"./lock-open.svg": "0608",
	"./logic.svg": "8409",
	"./mail.svg": "37a8",
	"./media.svg": "b374",
	"./more-icon.svg": "25f0",
	"./nodata.svg": "175b",
	"./number.svg": "eff2",
	"./object-list.svg": "d0b5",
	"./options.svg": "90bc",
	"./person-old.svg": "095d",
	"./person.svg": "fe85",
	"./plus-1.svg": "dc1a",
	"./quit.svg": "9efc",
	"./radiocard.svg": "4615",
	"./range-icon.svg": "8e95",
	"./refresh.svg": "8d7e",
	"./responsive.svg": "11e9",
	"./rm_negatives.svg": "281c",
	"./series_negative_val.svg": "afab",
	"./setting-white.svg": "483e",
	"./setting.svg": "6d1e",
	"./settings-to-chart.svg": "faca",
	"./share_grey.svg": "491d",
	"./solar.svg": "d476",
	"./sql_connect.svg": "add6",
	"./start.svg": "cf11",
	"./status_icon_failed.svg": "f092",
	"./status_icon_success.svg": "6f85",
	"./status_processing_icon.svg": "685f",
	"./text.svg": "4a68",
	"./textarea.svg": "ce9f",
	"./title.svg": "ec8d",
	"./todos.svg": "aa59",
	"./toggle.svg": "0b0e",
	"./user.svg": "f41a",
	"./video-icon.svg": "ae45",
	"./wind.svg": "66c5",
	"./wizard.svg": "6052",
	"./workflow-icon.svg": "c895",
	"./workflow.svg": "4e9c",
	"./x.svg": "8540"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1df";